import GENERATE_TRACEABILITY from '../queries/GENERATE_TRACEABILITY';
import UPDATE_LAST_CONNECTION from '../queries/UPDATE_LAST_CONNECTION';
const { clean, validate, format } = require('rut.js');
const moment = require('moment');
const { Auth } = require('aws-amplify');
const { has, get, isNil, keyBy, includes, map, size, orderBy, forEach, lowerCase, parseInt, split, head, replace, some, flatten, filter, isEmpty, difference, join, groupBy, omit, isString, isNumber, toNumber, find } = require('lodash');
const slugify = require('slugify');

const _get = (obj, key, defaultValue) => {
    return has(obj, key) && !isNil(get(obj, key)) && !includes(['null', 'undefined'], get(obj, key)) ? get(obj, key, defaultValue) : defaultValue;
};

const arrayIsNill = (array) => size(array) < 1;

const isEqualToZero = (value, negative, positive) => {
    if (value !== 0) return negative || value;
    return positive || '-';
};

const drawRates = (input, field) => {
    const values = input > 93 ? { arrow: 'arrow-up', color: '#1fa02e' } : { arrow: 'arrow-down', color: '#cc182e' };
    return get(values, field);
};

const getUserStatus = (format) => {
    const labels = [
        { key: 1, value: 'Disponible', color: '#1fa02e' },
        { key: 2, value: 'En Picking', color: '#1fa02e' },
        { key: 3, value: 'En Picking', color: '#b6d25d' },
        { key: 4, value: 'Desconectado', color: '#f38630' }
    ];
    return format ? labels.map(({ value }) => value) : keyBy(labels, 'key');
};

const getPickerType = (index) => {
    const labels = [
        'Interno',
        'Externo'
    ];
    return labels;
};

const getUserRole = (index) => {
    const labels = [
        'PickerSenior',
        'PickerJr',
        'Supervisor',
        'Administrador',
        'Gestor'
    ];
    return labels;
};

const getPickingStatus = (index) => {
    const status = {
        '1': 'available',
        '2': 'reserved',
        '3': 'in_picking',
        '4': 'pickeo_for_invoicing',
        '5': 'invoiced', // SHOW total price
        '6': 'bagging',
        '7': 'paused',
        '8': 'invoicing',
        '9': 'invoice_error',
        '20': 'pending',
        '22': 'pending_validation',
        '30': 'pending_audit_pre',
        '31': 'audit_rejected_pre',
        '32': 'pending_audit_post',
        '33': 'audit_rejected',
        '40': 'pending_cancellation',
        '41': 'cancelled'
    };
    return status[index] || index;
};

const productPickedCodes = (index) => {
    const key = String(index);
    const criteria = {
        '0': { label: 'Sin Pickear', code: 'UNPICKED' },
        '1': { label: 'Pickeado', code: 'PICKED' },
        '2': { label: 'Sustituto', code: 'REPLACE' },
        '3': { label: 'Sin Stock', code: 'OUT_STOCK' },
        '4': { label: 'Sustituto confirmado', code: 'SUBSTITUTE_CONFIRMED' },
        '5': { label: 'Sin Stock (Confirmado)', code: 'OUT_STOCK_ACCEPTED' },
        '6': { label: 'REPICKING_SUBSTITUTE_CONFIRMED', code: 'REPICKING_SUBSTITUTE_CONFIRMED' },
        '7': { label: 'REPICKING_OUT_STOCK_ACCEPTED', code: 'REPICKING_OUT_STOCK_ACCEPTED' },
        '8': { label: 'PARTIAL', code: 'PARTIAL' },
        '9': { label: 'FREE_PICKING', code: 'FREE_PICKING' },
        '10': { label: 'UNPICK_ADDED_BY_CLIENT', code: 'UNPICK_ADDED_BY_CLIENT' },
        '11': { label: 'ADDED_BY_CLIENT', code: 'ADDED_BY_CLIENT' },
        '12': { label: 'PARTIAL_ACCEPTED', code: 'PARTIAL_ACCEPTED' },
        '13': { label: 'FREE_PICKING_ACCEPTED', code: 'FREE_PICKING_ACCEPTED' }
    };
    return { key, value: criteria[key] || criteria['1'] };
};

const productPickingType = (label) => {
    const currentFilterKey = {
        'free-picking': ['FREE_PICKING', 'FREE_PICKING_ACCEPTED'],
        'partial-picking': ['PARTIAL', 'PARTIAL_ACCEPTED'],
        'picked': ['PICKED', 'PICK-VALIDATE'],
        'substitute': ['REPLACE', 'SUBSTITUTE_CONFIRMED', 'REPICKING_SUBSTITUTE_CONFIRMED'],
        'no-stock': ['OUT_STOCK', 'OUT_STOCK_ACCEPTED', 'REPICKING_OUT_STOCK_ACCEPTED'],
        'added': ['ADDED_BY_CLIENT'],
        'unpicked': ['UNPICKED'],
        'removed': ['UNPICK_ADDED_BY_CLIENT'],
        'unpicked-store': ['UNPICK_BY_STORE']
    };
    const result = Object.keys(currentFilterKey).reduce((label, type, key) => {
        if (currentFilterKey[type].includes(label)) return type;
        return label;
    }, label);
    return result;
};

const thirdPartyCompanies = ({ nonCenco } = { nonCenco: false }) => {
    const cencoCompanies = [
        'Cencosud',
        'París',
        'Jumbo'
    ];
    const externalCompanies = [
        'Boosmap',
        'Time Jobs',
        'GPS',
        'Puente Sur',
        'Carlos Díaz',
        'Transecom',
        'Alcansa',
        'Transportes 240',
        'Zubale',
        'Santa Isabel',
        'Spid',
        'Romeley',
        'DG Picking',
        'Picking240',
        'Aban',
        'Zwork'
    ];
    return map(nonCenco ? externalCompanies : [...cencoCompanies, ...externalCompanies], (value) => ({ value: slugify(value), label: value }));
};

const baggingEnums = {
    1: 'Bolsa',
    2: 'Bolsa',
    3: 'Bolsa',
    4: 'Caja',
    5: 'Mochila Jumbo',
    6: 'Bulto',
    7: 'Frescos',
    8: 'Congelados',
    9: 'Bolso Térmico'
};

const commonScheduleWindow = [
    { id: 0, window: '08:30 - 11:00' },
    { id: 1, window: '09:30 - 12:00' },
    { id: 2, window: '10:30 - 13:00' },
    { id: 3, window: '11:30 - 14:00' },
    { id: 4, window: '12:30 - 15:00' },
    { id: 5, window: '13:30 - 16:00' }
];

const staticScheduleWindows = {
    jumbo: {
        Despacho: [
            ...commonScheduleWindow,
            { id: 6, window: '14:30 - 17:00' },
            { id: 7, window: '15:30 - 18:00' },
            { id: 8, window: '16:30 - 19:00' },
            { id: 9, window: '17:30 - 20:00' },
            { id: 10, window: '18:30 - 21:00' },
            { id: 11, window: '19:30 - 22:00' }
        ],
        dayWeek: {
            bussiness: [
                { id: 0, window: '09:30 - 11:30' },
                { id: 1, window: '10:30 - 12:30' },
                { id: 2, window: '11:30 - 13:30' },
                { id: 3, window: '12:30 - 14:30' },
                { id: 4, window: '13:30 - 15:30' },
                { id: 5, window: '14:30 - 16:30' },
                { id: 6, window: '15:30 - 17:30' },
                { id: 7, window: '16:30 - 18:30' },
                { id: 8, window: '17:30 - 19:30' },
                { id: 9, window: '18:30 - 20:30' },
                { id: 10, window: '19:30 - 21:00' }
            ],
            saturday: [
                ...commonScheduleWindow
            ],
            sunday: []
        }
    },
    sisa: [
        { id: 0, window: '10:30 - 12:00' },
        { id: 1, window: '12:30 - 14:00' },
        { id: 2, window: '15:00 - 16:30' },
        { id: 3, window: '16:30 - 17:30' }
    ]
};

const preventDefault = (e, fn) => {
    e.preventDefault();
    fn();
};

const genUUID = () => {
    let d = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        // tslint:disable-next-line:no-bitwise
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        // tslint:disable-next-line:no-bitwise
        return (c === 'x' ? r : (r & 0x7) | 0x8).toString(16);
    });
    return uuid;
};

const toXXnumber = (number) => number >= 10 ? number : `0${number}`;

const formatTime = (n, debug) => {
    let num = n;
    let hours = (num / 60);
    let rhours = Math.floor(hours);
    let minutes = (hours - rhours) * 60;
    let rminutes = Math.round(minutes);
    const label = `${toXXnumber(rhours)}:${toXXnumber(Math.round(minutes))}`;
    return debug ? { rhours, rminutes, formatted: label } : label;
};

const timeDiffIn = (time, unit = 'minutes', diffDate = new Date()) => {
    const diff = moment(diffDate).diff(moment(time), unit);
    return diff;
};

const validateRut = (value) => {
    const cleanValue = clean(value);
    const validateValue = validate(cleanValue) && (size(cleanValue) >= 8);
    return validateValue;
};

const isPluralFix = (count, str) => count > 1 ? str : str.substr(0, str.length - 1);

const orderByDate = (input, fieldName, dir) => (orderBy(input, (item) => {
    return new Date(get(item, fieldName, 'createdAt')).getTime();
}, [dir]));

const getItemQuantity = (item) => {
    const quantity = get(item, 'quantity', '0');
    const unitMultiplier = get(item, 'unitMultiplier', '0');
    const measureUnit = get(item, 'unit', 'un');
    if (String(quantity) === '0') return size(get(item, 'quantity', 0)) ? '-' : get(item, 'quantity', '-');
    const calc = quantity * parseFloat(unitMultiplier);
    let result = 0;
    if (measureUnit === 'uni') result = (calc * 100) / 100;
    else result = calc.toFixed(3);
    return `${(String(result)).replace('.', ',')} ${measureUnit}`;
};

const removedItemsCount = (data) => {
    const allItems = get(data, 'items');
    let count = 0;
    forEach(get(data, 'assignInfo.removedItems', []), ({ id: removedId }) => {
        forEach(allItems, ({ id: allItemId, sellingPrice, quantity }) => {
            if (removedId === allItemId) {
                count += (parseInt(sellingPrice) * parseInt(quantity));
            }
        });
    });
    return count;
};

const dashZero = (number) => number <= 0 ? '-' : number;

const getPickingQuantityByUni = ({ unit, pickingQuantity }) => {
    if (lowerCase(unit) === 'uni') return parseInt(pickingQuantity);
    return 1;
};

const cleanOrderId = (orderId) => replace(head(split(orderId, '-0')), /v|jmch|sisa/gi, '');

const USER_STATUS_LIST = getUserStatus(true);
const PICKER_TYPE_LIST = getPickerType();
const PICKER_ROLE_LIST = getUserRole();
const validations = {
    document: {
        clean,
        format,
        validate
    }
};

const currentUserInfo = async () => {
    const userInfo = await Auth.currentSession();
    return {
        name: get(userInfo, 'idToken.payload.name'),
        lastName: get(JSON.parse(get(userInfo, 'idToken.payload.user')), 'lastName', null),
        phone: get(userInfo, 'idToken.payload.phone_number'),
        email: get(userInfo, 'idToken.payload.email'),
        email_verified: get(userInfo, 'idToken.payload.email_verified')
    };
};

const hasPermissionBySalesChannel = (salesChanneCollection = [], value = null, key = 'id') => some(salesChanneCollection, [`${key}`, value]);

const storeKindBySalesChannel = (id) => {
    if (parseInt(id) >= 100) return 'sisa';
    return 'jumbo';
};

const salesChannelKind = (data) => {
    const orderedSalesChannelbyKind = groupBy(data, 'kind');
    return map(orderedSalesChannelbyKind, (value, i) => ({ value: i, label: i }));
};

const orderProductsByStatus = (data = []) => {
    const getItemsByStatus = (items, status) => filter(items, item => includes(status, get(item, 'status', get(item, 'picking.status'))));
    const pickingStatus = {
        added: ['ADDED_BY_CLIENT'],
        picked: ['PICKED', 'PARTIAL', 'PARTIAL_ACCEPTED', 'PICK-VALIDATE'],
        composed: ['FREE_PICKING', 'FREE_PICKING_ACCEPTED'],
        replaced: ['REPLACE', 'SUBSTITUTE_CONFIRMED', 'REPICKING_SUBSTITUTE_CONFIRMED'],
        outStock: ['OUT_STOCK', 'OUT_STOCK_ACCEPTED', 'REPICKING_OUT_STOCK_ACCEPTED'],
        removedByClient: ['UNPICK_ADDED_BY_CLIENT'],
        refused: ['UNPICK_BY_STORE']
    };
    return flatten(map(pickingStatus, status => getItemsByStatus(data, status)));
};

const orderInPicking = (code) => {
    const beetrackStatus = ['50', '51', '53', '54', '55', '56', '57', '58', '59', '60'];
    const shouldShowPicking = includes([ '4', '5', '6', '8', '30', '31', '32', '33', '34', '40', '41',
        ...beetrackStatus
    ], String(code));
    return shouldShowPicking;
};

const removeNullFieldsFromVariables = (input) => {
    const { filters, ...more } = input;
    const cleanNullFields = filter(filters, ({ value }) => !isEmpty(value));
    return { ...more, filters: cleanNullFields };
};

const generateTraceabilityUtil = async (client, input) => {
    const errorMessage = 'Error on generate traceability';
    // idUser ---> User affected by mutation
    const { actionId } = input;
    if (!client || !actionId) return console.log(errorMessage);
    const { email } = await currentUserInfo();
    const variables = {
        input: {
            application: 'backoffice',
            createdBy: email,
            quantityAffected: 1,
            idUser: email,
            ...input
        }
    };
    try {
        const response = await client.mutate({
            mutation: GENERATE_TRACEABILITY,
            variables
        });
        return get(response, 'data.createTraceability', {});
    } catch (error) {
        console.log(error);
        return error;
    }
};

const updateLastConnection = async (client) => {
    const { email } = await currentUserInfo();

    try {
        const response = await client.mutate({
            mutation: UPDATE_LAST_CONNECTION,
            variables: {
                input: {
                    email: email
                }
            }
        });
        return get(response, 'data.updateLastConnection', {});
    } catch (error) {
        console.log(error);
        return error;
    }
};

const sameDataComparator = (input1, input2, response = { positive: true, negative: false }) => {
    const { positive, negative } = response;
    const hasCollection = includes(['object', 'array'], typeof input2);
    const hasSameSize = size(input1) === size(input2);
    if (typeof input1 !== typeof input2) return negative;
    if (hasCollection && hasSameSize) {
        if (!size(difference(input1, input2)) || !size(difference(input2, input1))) return positive;
    }
    if (hasCollection && !hasSameSize) return negative;
    if (input1 === input2) return positive;
    return negative;
};

const isSISAUrl = includes([window.location.host], 'backoffice.santaisabel.cl');

const employeeType = [{ value: '1', label: 'Externo' }, { value: '0', label: 'Interno' }];

const autoSetEmployeeType = company => includes(['paris', 'cencosud', 'jumbo'], lowerCase(company)) ? employeeType[0] : employeeType[1];

const statusUser = [
    { label: 'Activo', value: '0' },
    { label: 'Inactivo', value: '1' }
];

// Isn't same as statusUser. shopperStatus are statuses for avtive shoppers on sales channels
const shopperStatus = [
    { label: 'Disponible', value: '1' },
    { label: 'Reservado', value: '2' },
    { label: 'En Picking', value: '3' },
    { label: 'Desconectado', value: '4' },
    { label: 'Reservado', value: '20' }
];

const autoTypeUser = (company) => {
    const typeOptions = { '0': { value: '0', label: 'Interno' }, '1': { value: '1', label: 'Externo' } };
    if (includes(['paris', 'cencosud', 'jumbo'], lowerCase(company))) return typeOptions[0];
    return typeOptions[1];
};

const createSalesChannelsPayload = (base, selected) => map(base, ({ id, value }) => {
    return {
        salesChannelId: id || value,
        isActive: false,
        action: includes(map(selected, 'value'), id || value) ? 1 : 2
    };
});

const formatRefId = id => {
    const numbers = head(split(id, '-'));
    return `${join(new Array(19 - size(numbers)), '0')}${numbers}`;
};

const companyGroups = ['Jumbo', 'SISA', 'SPID35'];
const platform = [{ id: 1, name: 'mobile' }, { id: 2, name: 'web' }, { id: 3, name: 'todas' }];
const shipping = [{ id: 1, name: 'inmediato' }, { id: 2, name: 'programada' }];
const storesKind = [
    { id: '1', name: 'Jumbo' },
    { id: '2', name: 'SISA' },
    { id: '3', name: 'SPID35' }
];

const hasPermissionByResource = ({ session, to }) => includes(get(session, 'resources', []), to);

const holidays = ['1/1', '1/5', '18/9', '19/9', '25/12'];

const disabledShippingDates = (current) => {
    const date = moment();
    date.hour(0);
    date.minute(0);
    date.second(0);
    // bloquea los feriados irrenunciables
    if (includes(holidays, `${current.date()}/${current.month() + 1}`)) return true;
    // bloquea si la fecha de cada item es menor a hoy
    if (current && current.startOf('day').valueOf() < moment().startOf('day').valueOf()) return true;
};

const calculateBillingDeadline = (category, time, init, end, isAnticipated) => {
    if (isAnticipated) return moment(init).subtract(time, 'minutes');
    if (category === 'AUTO') return moment(init).subtract(30, 'minutes');

    if (category === 'CERCANO' || (isEmpty(category) && isEmpty(time))) {
        const auxNewHours = moment(moment(end).diff(moment(init), 'minutes')) / 2;
        return moment(init).add(auxNewHours, 'minutes');
    }

    return category === 'Lejano'
        ? moment(init).add(time, 'minutes')
        : moment(init).subtract(time, 'minutes');
};

const userModuleTypes = {
    0: 'users',
    1: 'shoppers',
    2: 'opers',
    3: 'salesChannels'
};

const getFilterSlaType = (sla) => {
    switch (sla) {
    case 'Despacho':
        return ['domicilio', 'especial'];
    case 'Retiro en Tienda':
        return ['tienda'];
    case 'Click al Auto':
        return ['auto'];
    }
};

const getSessionSalesChannel = (session) => orderBy(map(get(session, 'salesChannels'), ({ name, id, alternative_id: alternativeId, kind }) => ({ label: name, value: id, alternativeId, kind })), ['label'], ['asc']);

const statusOptions = [
    { label: 'Pendiente picking', value: ['1', '2', '20'].join('-') },
    { label: 'En picking', value: ['3'].join('-') },
    { label: 'Pickeado por facturar', value: ['4'].join('-') },
    { label: 'Facturado', value: ['5'].join('-') },
    { label: 'En Embolsado', value: ['6'].join('-') },
    { label: 'Por completar', value: ['7'].join('-') },
    { label: 'Facturando', value: ['8'].join('-') },
    { label: 'Error al facturar', value: ['9'].join('-') },
    { label: 'Pendiente auditoria', value: ['30', '32'].join('-') },
    // { label: 'Auditoria rechazada', value: ['31', '33'].join('-') },
    { label: 'Quiebre de Stock', value: ['34'].join('-') },
    // { label: 'Anulación en curso', value: ['40'].join('-') },
    { label: 'Anulado', value: ['41'].join('-') },
    { label: 'En Ruta', value: ['50'].join('-') },
    { label: 'Entregado', value: ['51'].join('-') },
    { label: 'Entregado Parcial', value: ['53'].join('-') },
    { label: 'No Entregado', value: ['54', '55', '56', '57', '58', '59', '60'].join('-') },
    { label: 'En reprogramación', value: ['21'].join('-') },
    { label: 'Pendiente de validación', value: ['22'].join('-') }
];

const getStatusCode = (label) => {
    const option = statusOptions.find(option => option.label === label);
    return option ? option.value.split('-') : [];
};

const qrStatusOptions = [
    { label: 'door open', value: 1, type: 'success' },
    { label: 'barcode not found', value: 2, type: 'error' },
    { label: 'time expired', value: 3, type: 'error' },
    { label: 'barcode used', value: 4, type: 'error' },
  ];

const getQrStatusValues = (type) => {
    return qrStatusOptions
        .filter((option) => option.type === type)
        .map((option) => option.value);
};

const orderTypeOptions = [
    { label: 'Monopicking', value: 'monopicking' },
    { label: 'Bipicking', value: 'bipicking' }
];

const useReset = (hook = () => {}, interval = 50) => {
    hook(true);
    setTimeout(() => {
        hook(false);
    }, interval);
};

const arrayMove = (items, oldIndex, newIndex) => {
    const newPosition = newIndex > oldIndex ? newIndex + 1 : newIndex;
    const oldPosition = newIndex > oldIndex ? oldIndex : oldIndex + 1;
    items.splice(newPosition, 0, items[oldIndex]);
    items.splice(oldPosition, 1);
    return items;
};

const monthOptions = [
    { label: 'Enero', value: 1 },
    { label: 'Febrero', value: 2 },
    { label: 'Marzo', value: 3 },
    { label: 'Abril', value: 4 },
    { label: 'Mayo', value: 5 },
    { label: 'Junio', value: 6 },
    { label: 'Julio', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Septiembre', value: 9 },
    { label: 'Octubre', value: 10 },
    { label: 'Noviembre', value: 11 },
    { label: 'Diciembre', value: 12 }
];

const typeQuestions = {
    MULTIPLE: 1,
    CSAT: 2,
    NPS: 3,
    SIMPLE: 4,
    OPEN: 5
};

const typeQuestionOptions = [
    { label: 'Opción múltiple', value: 1, MULTIPLE: 1 },
    { label: 'CSAT', value: 2, CSAT: 2 },
    { label: 'NPS', value: 3, NPS: 3 },
    { label: 'Opción simple', value: 4, SIMPLE: 4 },
    { label: 'Pregunta abierta', value: 5, OPEN: 5 }
];

const satisfactionOptions = [
    { name: 'poor', color: '#E54717', translate: 'Nada satisfecho', value: 12 },
    { name: 'poor', color: '#FF8A00', translate: 'Poco satisfecho', value: 13 },
    { name: 'average', color: '#DBC716', translate: 'Normal', value: 14 },
    { name: 'good', color: '#166DC2', translate: 'Satisfecho', value: 15 },
    { name: 'excellent', color: '#22A889', translate: 'Muy satisfecho', value: 16 }
];

const isGenUUID = (item, key) => isString(get(item, key));

const getIdReference = (item, key) => {
    if (isGenUUID(item, key)) {
        if (key === 'idCondition') {
            return {
                idFrontReferenceQuestion: isNumber(get(item, 'idNextQuestion')) ? '' : get(item, 'idNextQuestion'),
                idFrontReferenceOption: isNumber(get(item, 'idOptions')) ? '' : get(item, 'idOptions')
            };
        }
        if (key === 'idQuestion') return { idFrontReference: get(item, 'idQuestion') };
        if (key === 'idOption') return { idFrontReference: get(item, 'idOption') };
    }
};

const updateFieldsConditions = (question, key) => {
    const conditions = get(question, 'conditions');
    return map(conditions, (item) => {
        const idFrontReference = getIdReference(item, key);
        const updatedItem = { ...omit(item, '__typename'), ...idFrontReference || {}, idQuestion: get(question, 'idQuestion') };
        const valuesToSkip = [
            key,
            isGenUUID(updatedItem, 'idNextQuestion') ? 'idNextQuestion' : '',
            isGenUUID(updatedItem, 'idOptions') ? 'idOptions' : ''
        ];

        return isGenUUID(updatedItem, key)
            ? omit(updatedItem, valuesToSkip)
            : updatedItem;
    });
};

const updateFields = (items, key) => {
    return map(items, (item, index) => {
        const idFrontReference = getIdReference(item, key);
        const updatedItem = { ...omit(item, '__typename'), ...idFrontReference || {} };
        
        return isGenUUID(updatedItem, key) ? omit(updatedItem, key) : updatedItem;
    });
};

const validateQuestions = (questions) => {
    const validatedQuestions = updateFields(questions, 'idQuestion');
    return map(validatedQuestions, (question, index) => {
        const options = updateFields(get(question, 'options'), 'idOption');
        const conditions = updateFieldsConditions(question, 'idCondition');
        return { ...question, options, conditions, orden: index + 1 };
    });
};

const formatMonthEvaluate = (months) => {
    return map(months, ({ value }) => {
        const month = find(months, { months_evaluate: value })
        return month ? omit(month, '__typename') : { months_evaluate: value }
    })
}

const formatActivationRange = (range) => {
    return [{ ...range, init: get(range, 'init').format('YYYY-MM-DD'), end: get(range, 'end').format('YYYY-MM-DD') }];
};

const getFlagStore = (idStore, sessionSalesChannel) => {
    const store = find(sessionSalesChannel, { value: idStore });
    const flag = toNumber(get(find(storesKind, { name: get(store, 'kind') }), 'id'));
    return flag || 0;
};


const formatStores = (stores, previousStores, sessionSalesChannel) => map(stores, ({ value }) => {
    const storePreviewFound = find(previousStores, { idStore: toNumber(value) })
    return storePreviewFound
        ? omit(storePreviewFound, '__typename')
        : {
        idStore: toNumber(value),
        amount: 100,
        status: 1,
        flag: getFlagStore(value, sessionSalesChannel)
    };
});

const addAuxId = (items, key) => map(items, (i) => ({ ...i, id: get(i, key)}))

const addUUID = (questions, isDuplicate = false) => {
    const questionsAndOptionsUpdated = map(addAuxId(questions, 'idQuestion'), (question) => {
        const questionUUID = genUUID()

        const options = map(addAuxId(get(question, 'options'), 'idOption'), (option) => {
            return { ...option, idFrontReference: genUUID() }
        }) 

        return { ...question, idFrontReference: questionUUID, options }
    })  

    const questionsUpdated = map(questionsAndOptionsUpdated, (question) => {
        const idTypeQuestion = get(question, 'idTypeQuestion')
        const isCSAT = idTypeQuestion === typeQuestions.CSAT

        const conditionsOptions = map(get(question, 'conditions'), (condition) => {
            const optionFound = find(get(question, 'options'), { id: get(condition, 'idOptions')})
            const nextQuestionFound = find(questionsAndOptionsUpdated, { id: get(condition, 'idNextQuestion')})
            const idNextQuestionOmit = isDuplicate ? [] : ['idNextQuestion']
            const elementsOmitFromConditions = [...['idCondition', 'idOptions', 'idQuestion'], ...idNextQuestionOmit]

            return {
                ...omit(condition, elementsOmitFromConditions),
                idFrontReferenceOption: idTypeQuestion === typeQuestions.CSAT ? '' : get(optionFound, 'idFrontReference'),
                ...(!isDuplicate && { idFrontReferenceQuestion: get(nextQuestionFound, 'idFrontReference') }),
                ...((!isDuplicate) && { idOptions: isCSAT ? get(optionFound, 'idOption') : 0 }),
            }
        })

        const idOption = isCSAT ? [] : ['idOption']
        const elementsOmitFromOption = [...['id', 'idQuestion'], ...idOption]

        return {
            ...omit(question, ['id', 'idQuestion']),
            conditions: conditionsOptions,
            options: map(get(question, 'options'), (option) => omit(option, elementsOmitFromOption))
        }
    })

    return questionsUpdated
}

const quantityRenderer = (quantity, single, multiple) => {
    if (quantity > 1) return multiple;
    return single;
};

const secondsToHms = (seconds) => {
    seconds = Number(seconds);
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = Math.floor(seconds % 3600 % 60);

    return `${h}hr ${m}min ${s}sg`;
}


const capitalizeNames = (name) => {
    if (!name) return '';
    return name.split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

const USER_STATUS = {
    ACTIVE: 0,
    INACTIVE: 1,
  };


export {
    getUserStatus,
    getUserRole,
    getPickerType,
    getPickingStatus,
    USER_STATUS_LIST,
    PICKER_TYPE_LIST,
    PICKER_ROLE_LIST,
    validations,
    productPickedCodes,
    productPickingType,
    preventDefault,
    _get,
    genUUID,
    formatTime,
    timeDiffIn,
    thirdPartyCompanies,
    validateRut,
    isPluralFix,
    orderByDate,
    getItemQuantity,
    removedItemsCount,
    dashZero,
    toXXnumber,
    getPickingQuantityByUni,
    cleanOrderId,
    currentUserInfo,
    arrayIsNill,
    baggingEnums,
    staticScheduleWindows,
    hasPermissionBySalesChannel,
    storeKindBySalesChannel,
    salesChannelKind,
    orderProductsByStatus,
    orderInPicking,
    isEqualToZero,
    drawRates,
    removeNullFieldsFromVariables,
    isSISAUrl,
    generateTraceabilityUtil,
    sameDataComparator,
    employeeType,
    autoSetEmployeeType,
    statusUser,
    shopperStatus,
    autoTypeUser,
    createSalesChannelsPayload,
    formatRefId,
    companyGroups,
    hasPermissionByResource,
    platform,
    shipping,
    storesKind,
    holidays,
    disabledShippingDates,
    calculateBillingDeadline,
    userModuleTypes,
    getFilterSlaType,
    getSessionSalesChannel,
    statusOptions,
    useReset,
    arrayMove,
    monthOptions,
    typeQuestions,
    typeQuestionOptions,
    satisfactionOptions,
    validateQuestions,
    formatMonthEvaluate,
    formatActivationRange,
    formatStores,
    addUUID,
    quantityRenderer,
    updateLastConnection,
    orderTypeOptions,
    secondsToHms,
    getStatusCode,
    qrStatusOptions,
    getQrStatusValues,
    capitalizeNames,
    USER_STATUS
};
